<template>
  <div>
    <!-- 列表组件 -->
    <qyjbxx-2 v-if="dialogForm" ref="qyjbxx2" @getTreeData="testData" />
    <!-- 新增和编辑组件 -->
    <qyxxbg-dialog-father
      v-if="!dialogForm && !lookFlag"
      ref="qyxxbgDialog"
      v-loading="loading"
      :edit-id="editId"
    />
    <!-- 查看数据组件 用两个组件是因为编辑和查看返回的数据格式不同-->
    <qyxxbg-look-father v-if="!dialogForm && lookFlag" :look-id="lookId" />
  </div>
</template>

<script>
import Qyjbxx2 from '@/components/qyxxbg/qyxxbg2'
import QyxxbgDialogFather from '@/components/qyxxbg/qyxxbgDialogFather.vue'
import QyxxbgLookFather from '@/components/qyxxbg/qyxxbgLook/qyxxbgLookFather.vue'
import { addaddOrUpdSave, saveBgjlPdYwlx } from '@/assets/js/qyxxbg.js'
export default {
  name: 'Qyxxbg',
  components: {
    Qyjbxx2,
    QyxxbgDialogFather,
    QyxxbgLookFather
  },
  data() {
    return {
      loading: false,
      dialogForm: true, // 新增或者查看开关
      lookFlag: true, // 是否是查看
      editId: '' // 编辑id
    }
  },
  created() {
    // switch (this.$route.params.zjlx) {
    //   case '1':
    //     this.dialogForm = false
    //     this.lookFlag = false
    //     this.editId = this.$route.params.id
    //     break
    //   case '2':
    //     this.dialogForm = false
    //     this.lookFlag = false
    //     this.editId = this.$route.params.id
    //     break
    //   case '3':
    //     this.dialogForm = false
    //     this.lookFlag = false
    //     this.editId = this.$route.params.id
    //     break
    // }
  },
  beforeDestroy() {
    this.$bus.$off('qyxxbgLookExit')
    this.$bus.$off('exit')
    this.$bus.$off('qyxxbgSave')
  },
  mounted() {
    this.$bus.on('qyxxbgLookExit', () => {
      this.dialogForm = !this.dialogForm
    })
    this.$bus.on('exit', (val) => {
      this.dialogForm = !this.dialogForm
      this.lookFlag = !this.lookFlag
    })
    // 暂存或提交
    this.$bus.on('qyxxbgSave', (val) => {
      var pojo = {
        dwBgjlDto: this.$refs.qyxxbgDialog.dwBgjlDto, // 单位数据
        frBgjlDto: this.$refs.qyxxbgDialog.frBgjlDto, // 法人数据
        hxpBgjlDtos: this.$refs.qyxxbgDialog.hxpBgjlDtos, // 化学品数据
        zjlxs: this.$refs.qyxxbgDialog.todoDelZjlx.join(',') // 获取的是给后台传递 需要删除的证件数组
      }
      // 根据val 判断是草稿还是提交
      if (val == 1) {
        pojo.dwBgjlDto.zt = '00'
      } else if (val == 2) {
        pojo.dwBgjlDto.zt = '11'
      }
      // 判断(单位信息、法人信息、化学品信息、证件信息)变更模块
      var result = this.comparison()
      if (pojo.dwBgjlDto.bgmk) {
        // 有值 拼接
        pojo.dwBgjlDto.bgmk = pojo.dwBgjlDto.bgmk + ',' + result
      } else {
        // 无值  直接赋予
        pojo.dwBgjlDto.bgmk = result
      }
      this.loading = true
      const ywlxList = []
      this.$refs.qyxxbgDialog.hxpBgjlDtos.forEach(e => {
        ywlxList.push(e.ywlx)
      })
      saveBgjlPdYwlx(ywlxList).then(res => {
        var data = '是否确认变更?'
        if (res.data.data.type == 'success') {
        }
        // 如果没有可注意事项
        else {
          data =
            "<span style='color:red'>" +
            res.data.data.msg +
            '</span>是否确认变更?'
        }
        this.$confirm(data, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning',
          center: true
        })
          .then(() => {
            // 调用接口  param1   单位变更id    param2 表单数据
            addaddOrUpdSave(this.$refs.qyxxbgDialog.dwbgjlId, pojo)
              .then((e) => {
                this.dialogForm = !this.dialogForm // 关闭页面
                this.$nextTick(() => {
                  this.$refs.qyjbxx2.search() // 刷新列表
                })
                var info
                val == 1 ? (info = '暂存成功') : (info = '保存成功')
                this.$message({
                  message: info,
                  type: 'success'
                })
                this.loading = false
              })
              .catch((e) => {
                this.loading = false
              })
          })
          .catch(() => {
            this.loading = false
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      })
    })
  },
  methods: {
    testData(data) {
      // 列表页 跳转后判断是编辑还是查看
      if (data.hasOwnProperty('lookId')) {
        this.lookId = data.lookId // 查看
      }
      if (data.hasOwnProperty('id')) {
        this.editId = data.id
      }
      this.lookFlag = data.lookFlag
      this.dialogForm = data.dialogForm
    },
    // 判断变更模块的逻辑
    comparison() {
      var bgmk
      const dwbgOld = this.$refs.qyxxbgDialog.dwBgjlDtoOld // 单位信息修改前
      const dwbg = this.$refs.qyxxbgDialog.dwBgjlDto // 单位信息修改后
      var dwbgLabel = [
        // 只对比页面表单的数据
        'dwmc',
        'dwxz',
        'shtyxydm',
        'dwlx',
        'yyqxKs',
        'yyqxJs',
        'clrq',
        'zczb',
        'by2',
        'frmc',
        'dwzj',
        'cyrysl',
        'st',
        'sj',
        'qxj',
        'sjjyd',
        'jyfw',
        'yyzzUrl'
      ]
      const frbgOld = this.$refs.qyxxbgDialog.frBgjlDtoOld // 法人信息修改前
      const frbg = this.$refs.qyxxbgDialog.frBgjlDto // 法人信息修改后
      var farenLabel = [
        'zjzpZm',
        'zjzpFm',
        'xm',
        'xb',
        'zjhm',
        'mz',
        'sr',
        'jg',
        'yxqxKs',
        'yxqxJs',
        'fzjg',
        'bgdh',
        'sjhm',
        'sjzz'
      ]
      const hxpOld = this.$refs.qyxxbgDialog.hxpBgjlDtosOld // 化学品信息修改前
      const hxp = this.$refs.qyxxbgDialog.hxpBgjlDtos // 化学品信息修改后
      // 单位信息比较
      bgmk = this.objectcomparison(dwbgOld, dwbg, dwbgLabel) ? '01' : ''
      // 法人信息比较
      bgmk = this.objectcomparison(frbgOld, frbg, farenLabel)
        ? bgmk === ''
          ? '02'
          : bgmk + ',02'
        : bgmk
      // 化学品信息比较
      bgmk =
        this.arraycomparison(hxpOld, hxp) || this.$refs.qyxxbgDialog.isUpdate
          ? bgmk === ''
            ? '03'
            : bgmk + ',03'
          : bgmk
      return bgmk // 返回的变更模块
    },
    // 对象的前后比较方法
    objectcomparison(Old, New, Label) {
      try {
        Label.forEach((e) => {
          if (Old[e] !== New[e]) {
            throw new Error('ending')
          }
        })
        return false
      } catch (e) {
        if (e.message == 'ending') {
          return true
        } else {
          console.log(e.message)
        }
      }
    },
    // 数组的前后比较方法
    arraycomparison(Old, New) {
      if (Old.length != New.length) {
        return true
      }
      return JSON.stringify(Old) !== JSON.stringify(New)
    }
  }
}
</script>

<style scoped>
._content {
  background-color: #eef1f9;
}
</style>
